import React from 'react';

// PropTypes
import PropTypes from 'prop-types';

// MUI JOY components
import Divider from '@mui/joy/Divider';

// Typography
import { Body2, H5, Body3 } from '../../themes/typography';

// CSS Styles
import '../../styles/components/AttendeeTicketDetails.css';

const attendeesList = [
    {
        name: 'Prashant Chaute',
        email: 'prashantofficial@gmail.com'
    },
    {
        name: 'Prashant Chaute',
        email: 'prashantofficial12@gmail.com'
    }
];

export default function AttendeeTicketDetails({
    ticketName = 'Summer Music Festival Student Pass 2024',
    attendeesDetails = attendeesList,
    attendeesLength = 10
    // attendeesLength = attendeesDetails.length,
}) {
    return (
        <React.Fragment>
            <div className="attendee-ticket-purchase-main-container">
                {/* Attendee Details Section */}
                <section className="attendee-listing-section">
                    {/* Attendee Header Section */}
                    <div className="attendee-details-container">
                        <H5>Attendees</H5>
                        <div className="attendees-length">
                            <Body2>x{attendeesLength}</Body2>
                        </div>
                    </div>

                    {/* Separator */}
                    <Divider sx={{ backgroundColor: 'rgba(223, 223, 223, 0.28)' }} />

                    {/* Atttendees details listing section */}
                    <div className="attendee-details-listing-container">
                        {attendeesDetails.map((attendee, index) => {
                            return (
                                <div key={index} className="attendee-listing-container">
                                    <Body3 fontWeight={400}>{attendee.name}</Body3>
                                    <Body3>{attendee.email}</Body3>
                                </div>
                            );
                        })}
                    </div>
                </section>

                {/* Ticket Cuts Section */}
                <section className="ticket-cuts-section">
                    <div className="left-cut-container"></div>
                    <div className="center-cut-container"></div>
                    <div className="right-cut-container"></div>
                </section>

                {/* Ticket Name Section */}
                <section className="ticket-name-section">
                    <Body2 color="#f8a21e">{ticketName}</Body2>
                </section>
            </div>
        </React.Fragment>
    );
}

// PropTypes Validation
AttendeeTicketDetails.propTypes = {
    ticketName: PropTypes.string.isRequired,
    attendeesLength: PropTypes.number.isRequired || PropTypes.string.isRequired,
    attendeesDetails: PropTypes.array.isRequired
};
